export const guideSections = [
  {
    id: "what-hot",
    no: "01",
    title: "高热度选题长什么样",
    intro:
      "编辑每天看大量线索，能进入跟进名单的选题往往有几个共同点。与其追最热的话题，不如找一个你够得着、又有独家信息的切口。",
    points: [
      { label: "具体到可以落地", desc: "「某小区电梯停工两年」比「物业服务差」更容易被跟进，时间和地点就是可核实的基础。" },
      { label: "有一个明确冲突", desc: "谁和谁在为一件什么事僵持，冲突越清晰，报道的叙事越顺。" },
      { label: "有可公开的利益影响", desc: "关系到一批人的钱、健康或安全，读者才会关心，选题才有公共价值。" },
      { label: "你是离得最近的人", desc: "内部人、亲历者、长期观察者，比任何二手转述都更有说服力。" },
    ],
  },
  {
    id: "headline",
    no: "02",
    title: "爆款稿件的标题技巧",
    intro:
      "标题决定稿件被点开的第一秒。好的标题不靠夸张形容词，而是把最有信息量的那个细节提前，让人一眼看到事情的矛盾。",
    points: [
      { label: "用具体数字替代程度词", desc: "把「很久」换成「两年」、把「很多人」换成「三百位家长」，可核实的数字自带可信度。" },
      { label: "把代价讲出来", desc: "「交了一年房租，第七十三天被断水电」比「二房东跑路」更能让人代入。" },
      { label: "制造信息差而非悬念", desc: "不要写「结果令人震惊」，而是直接给出反差事实，把好奇心留给细节，把判断留给读者。" },
      { label: "控制在二十字左右", desc: "移动端一行能完整展示，核心信息不要被截断。" },
    ],
  },
  {
    id: "features",
    no: "03",
    title: "被采用稿件的共同特征",
    intro:
      "翻看被采用的稿件会发现，它们未必文笔最好，但都在几个维度上做对了。投稿前对照这些特征自查，过稿率会有明显变化。",
    points: [
      { label: "材料成组而非孤立", desc: "一张截图是线索，截图加合同加聊天记录加时间线，才是可发布的稿件。" },
      { label: "有真实的人在里面", desc: "出现具体当事人及其处境，读者才会共情，稿件才有温度。" },
      { label: "冲突有双方声音", desc: "给被指方一个回应的位置，稿件才经得起推敲，也不会在发布后被打脸。" },
      { label: "留下可核验的钩子", desc: "哪怕是模糊处理的凭证描述，也能让编辑相信这背后有真实材料。" },
    ],
  },
  {
    id: "editor",
    no: "04",
    title: "编辑偏好方向速查",
    intro:
      "不同媒体的编辑口味略有差异，但判断一篇投稿值不值得跟进，大方向是相通的。了解这些偏好，能帮你把力气用在正确的地方。",
    points: [
      { label: "偏爱有新进展的老话题", desc: "同一个事件，你能带来别人还没拿到的最新一步，就是加分项。" },
      { label: "偏爱能落到人的政策", desc: "政策类选题要落到具体家庭的具体变化，抽象分析很难被采用。" },
      { label: "偏爱可验证的数据", desc: "如果你能提供自己统计、实测或对比得到的小数据，会显著提高可信度。" },
      { label: "不喜欢情绪化控诉", desc: "把愤怒转化成事实与请求，编辑更容易判断如何帮忙。" },
    ],
  },
  {
    id: "reject",
    no: "05",
    title: "最常见的退稿原因",
    intro:
      "被退回不等于选题没价值，多数时候只是差了一点。下面这些原因占了退稿的大多数，提前避开能省下很多时间。",
    points: [
      { label: "通篇转述没有材料", desc: "只写「听说有人说」，编辑无法判断真假，只能搁置。" },
      { label: "信息过于笼统", desc: "没有时间、地点、当事人，选题无法落地，也无法核实。" },
      { label: "与现有报道高度重合", desc: "如果只是复述已有报道，缺少新角度或新证据，就会被判定为二手内容。" },
      { label: "涉及个人隐私却无授权", desc: "曝光具体个人之前，需要确认其与公共利益的关联以及授权情况。" },
    ],
  },
  {
    id: "checklist",
    no: "06",
    title: "投稿前自查清单",
    intro:
      "把这份清单当成投稿前的最后一关。全部打勾再提交，你和编辑的沟通成本都会低很多。",
    points: [
      { label: "时间、地点、人物是否都已写明", desc: "这是编辑判断能否跟进的第一道门槛。" },
      { label: "是否附上至少一份可核实的材料", desc: "截图、合同、票据、录音、现场照片，任选其一。" },
      { label: "标题是否包含一个具体细节", desc: "检查标题里有没有数字、时间或反差事实。" },
      { label: "是否说明你愿意配合哪些后续工作", desc: "能补充采访、能提供渠道，会大幅提高采用率。" },
    ],
  },
];

export const headlineExamples = [
  {
    before: "某小区物业问题严重，业主苦不堪言",
    after: "停车费三年涨了两次，业主把物业告上了法庭",
    reason: "具体数字与冲突，取代空泛形容词。",
  },
  {
    before: "关于外卖平台罚款的一点观察",
    after: "迟到四分钟扣掉一顿饭钱，申诉按钮点了一百次",
    reason: "用细节呈现代价，让规则失效变得可感。",
  },
  {
    before: "谈谈教培机构退费难的问题",
    after: "说好三十天退款，第九十天客服还在让我再等等",
    reason: "时间对比制造信息差，而非空喊口号。",
  },
];

export const submissionMaterials = [
  { icon: "ri-file-list-3-line", title: "一条清晰的时间线", desc: "事情从什么时候开始，中间发生了什么，现在到了哪一步。" },
  { icon: "ri-image-line", title: "至少一份原始材料", desc: "现场照片、合同、票据、聊天记录或录音任选其一。" },
  { icon: "ri-user-voice-line", title: "可联系的相关人", desc: "当事人或知情人的联系方式，方便编辑进一步核实。" },
  { icon: "ri-edit-2-line", title: "一段三百字的概述", desc: "用平实的语言讲清这件事，不必追求文采。" },
];